<template>
  <DialogHeader> Cancel upload </DialogHeader>
  <DialogContent>
    Are you sure you want to cancel uploading
    <span class="font-bold">{{ props.upload.fileName }}</span>
  </DialogContent>
  <DialogFooter class="flex-col-reverse tablet-h:flex-row gap-2.5">
    <UiButton class="w-full tablet-h:w-auto" @click="close()">
      No, keep uploading
    </UiButton>
    <UiButton class="w-full tablet-h:w-auto" danger @click="handleClick">
      Yes, cancel upload
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { useUploadStore, type Upload } from '@/features/upload/store'
import { ErrorCodes } from '@/shared/graphql/legacy/generated'
import posthog from 'posthog-js'

const props = defineProps<{
  upload: Upload
}>()

const { close } = useDialog()
const uploadStore = useUploadStore()

const handleClick = () => {
  props.upload.abortController.abort()

  uploadStore.setUploadError(props.upload._id, {
    error: ErrorCodes.UploadError,
    canceled: true,
  })

  posthog.capture('copyright_upload_cancelled', {
    id: props.upload.id,
    fileName: props.upload.fileName,
    source: 'web',
    size: props.upload.size,
  })

  close()
}
</script>
